import React from "react";
import "./Loader.css";

const Loader = (props) => {
  return <div className={`loader_spinner ${props.display}`}></div>;
};

export default Loader;
